import { Typography } from '@mui/material';
import payRangeHelper from '@/utils/payRangeHelper';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';

interface CaregiverPayRangeProps {
  caregiver: Caregiver;
}

const CaregiverPayRange = ({ caregiver }: CaregiverPayRangeProps) => {
  const { yearsOfExperience } = caregiver;

  const caregiverProfile = caregiver.profiles?.commonCaregiverProfile;

  const payRangeText = payRangeHelper(
    caregiverProfile?.payRange?.hourlyRateTo.amount || '',
    caregiverProfile?.payRange?.hourlyRateFrom.amount || '',
    true
  );

  return (
    <Typography variant="h4">
      <span>{payRangeText}</span>
      {yearsOfExperience > 0 && <span> • {yearsOfExperience} yrs exp</span>}
    </Typography>
  );
};

export default CaregiverPayRange;
